var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "datepicker__input",
    class: _vm.inputClass,
    attrs: { "data-qa": "datepickerInput", tabindex: _vm.tabIndex },
    domProps: {
      textContent: _vm._s(
        _vm.inputDate ? _vm.inputDate : _vm.i18n[_vm.inputDateType]
      )
    },
    on: {
      click: _vm.toggleDatepicker,
      keyup: function($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        ) {
          return null
        }
        $event.stopPropagation()
        $event.preventDefault()
        return _vm.toggleDatepicker($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-c0f76288", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0f76288","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateInput.vue
// module id = 61
// module chunks = 0